export default __webpack_public_path__ + "static/media/bi.2bd8aa21.svg";